import { defineComponent, PropType } from 'vue';
import { IProps } from './type.d';

/**
 * 公共表格组件
 */
export default defineComponent({
  props: {
    data: {
      type: Array as PropType<IProps['data']>,
      required: true,
      default: () => [],
    },
    columns: {
      type: Array as PropType<IProps['columns']>,
      required: true,
      default: () => [],
    },
  },
  setup() {
    const renderTableItem = (column: IProps['columns'][0]) => {
      const renderFun = column.render;
      const key = column.prop;
      if (renderFun) {
        return {
          default: ({ row, $index }: any) => renderFun(row, $index),
        };
      }
      if (key) {
        return {
          default: ({ row }: any) => row[key],
        };
      }
      return undefined;
    };
    return {
      renderTableItem,
    };
  },
  render() {
    return (
      <el-table
        border={true}
        size="default"
        {...this.$attrs}
        data={this.data}
      >
        {this.columns.map(v => (
          <el-table-column
            type={v.type}
            label={v.label}
            width={v.width}
            minWidth={v.minWidth}
            fixed={v.fixed}
            align={v.align}
            show-overflow-tooltip={v.ellipsis}
            v-slots={this.renderTableItem(v)}
            selectable={v.selectable ? (row: any, index: number) => v.selectable(row, index) : null}
          />
        ))}
      </el-table>
    );
  },
});
